import { isString, get, omitBy, isNil } from 'lodash-es';
import moment from 'moment';
import type { CoreTypes } from '../../core';
import type { Room } from '../types/rooms';
import { getDivisionId, hasDivisionId, type DivisionScope } from './common';

/**
 * @deprecated This is only used for SCS. can be removed when scs use v2
 */
export default (
  locations: (Extract<CoreTypes.Mixed.Location, { id: string }> | string)[],
  domain?: DivisionScope
): Room[] => {
  if (!Array.isArray(locations))
    throw new Error('(SS12000::To::Room) Room input is not of array type', { cause: 'invalid_input' });

  if (!locations.every((location) => isString(location) || isString(get(location, 'id'))))
    throw new Error('(SS12000::To::Room) Some locations are missing "id" values', { cause: 'invalid_input' });

  if (!domain && !locations.every((location) => !isString(location) && hasDivisionId(location)))
    throw new Error('(SS12000::To::Room) Some top layer locations are missing division values', { cause: 'invalid_input' });

  return locations.map((location) => ({
    id: `${ getDivisionId(location, domain) }.${ isString(location) ? location : location.id }`,
    ...!isString(location) && {
      meta: {
        created:  moment(location.createdAt).toISOString(),
        modified: moment(location.updatedAt).toISOString()
      },
      ...omitBy({
        foreignId:   location.ids,
        displayName: location.displayName,
        seats:       location.maximumCapacity,
        tags:        location.tags,
      }, isNil),
    }
  }));
};